/* istanbul ignore file */
import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import useSound from 'use-sound';

const variants = {
  initial: { scale: 0 },
  animate: {
    scale: 2,
    transition: {
      delay: 0,
    },
  },
};

const RecordTimer = ({ seconds, onFinished }: { seconds: number; onFinished: Function }) => {
  const [play] = useSound('/sounds/boop.mp3');
  const [status, setStatus] = useState<string>('animate');
  const [recordTimerSeconds, setRecordTimerSeconds] = useState<number>(seconds);

  useEffect(() => {
    const myInterval: ReturnType<typeof setInterval> = setInterval(() => {
      if (recordTimerSeconds === 0) {
        clearInterval(myInterval);
        onFinished();
      } else {
        play();
        setStatus('animate');
        setRecordTimerSeconds(recordTimerSeconds - 1);
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  });

  useEffect(() => {
    console.log(recordTimerSeconds, seconds);

    if (recordTimerSeconds === seconds) {
      console.log('play here');
      play();
    }
  }, [seconds]);

  return (
    <div className="absolute text-5xl text-white shadow-lg">
      <motion.div
        initial={'initial'}
        variants={variants}
        animate={status}
        onAnimationComplete={() => setStatus('initial')}
      >
        {recordTimerSeconds === 0 ? 'Go' : recordTimerSeconds}
      </motion.div>
    </div>
  );
};

export default RecordTimer;
